import cn from 'classnames';
import { LoanReviewStatus, loanReviewStatusTitles } from '../../types/loan/LoanReviewStatus';
import { Popover } from '../controls/Popover';

const statusClass: Record<LoanReviewStatus, string> = {
    [LoanReviewStatus.InReview]: 'status-pending',
    [LoanReviewStatus.Approved]: 'status-confirmed',
    [LoanReviewStatus.Passed]: 'status-canceled',
};

interface LoanReviewStatusLabelProps {
    review: LoanReviewStatus;
    issuer: string;
    passingReasons?: string[];
    otherPassingReasons?: string;
}

export function LoanReviewStatusLabel({ review, issuer, passingReasons, otherPassingReasons }: LoanReviewStatusLabelProps) {
    const label = loanReviewStatusTitles[review];
    const className = cn('status', statusClass[review]);

    if (review === LoanReviewStatus.Passed && (passingReasons?.length || otherPassingReasons)) {
        return (
            <Popover
                title="Reason(s) for passing"
                label={<span className="name-tag text-ellipsis">{issuer}</span>}
                actionButton={
                    <button className={cn('pseudo-link', className)}>
                        {label}
                    </button>
                }
            >
                <ul className="passed-reasons-list">
                    {passingReasons?.concat(otherPassingReasons || []).map((reason, index) => (
                        <li key={index} className="popover-item">
                            {reason}
                        </li>
                    ))}
                </ul>
            </Popover>
        );
    }

    return <span className={className}>{label}</span>;
}
